module.exports = __webpack_public_path__ + "static/media/galway-17.cbc92015.jpg";